"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var CartHOC = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CartHOC, _React$Component);

  var _super = _createSuper(CartHOC);

  (0, _createClass2["default"])(CartHOC, null, [{
    key: "normalizeHour",
    value: function normalizeHour(hour) {
      var hourAsString = hour.toString();
      if (!hourAsString) return null;
      if (hourAsString.length === 2) return "00".concat(hourAsString);
      if (hourAsString.length === 3) return "0".concat(hourAsString);
      return hourAsString;
    }
  }]);

  function CartHOC(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CartHOC);
    _this = _super.call(this, props);
    _this.state = {
      items: []
    };
    _this.addItem = _this.addItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.removeItem = _this.removeItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateItem = _this.updateItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.containsItem = _this.containsItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearCart = _this.clearCart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getItemIndex = _this.getItemIndex.bind((0, _assertThisInitialized2["default"])(_this));
    _this.isOpen = _this.isOpen.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(CartHOC, [{
    key: "getItemIndex",
    value: function getItemIndex(item) {
      var lookupFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
        return key;
      };
      var items = this.state.items;
      return items.map(function (aItem) {
        return lookupFunc(aItem);
      }).indexOf(lookupFunc(item));
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      this.setState(function (_ref) {
        var items = _ref.items;
        return {
          items: [].concat((0, _toConsumableArray2["default"])(items), [item])
        };
      });
    }
  }, {
    key: "removeItem",
    value: function removeItem(index) {
      this.setState(function (_ref2) {
        var items = _ref2.items;
        return {
          items: [].concat((0, _toConsumableArray2["default"])(items.slice(0, index)), (0, _toConsumableArray2["default"])(items.slice(index + 1, items.length)))
        };
      });
    }
  }, {
    key: "updateItem",
    value: function updateItem(item, index) {
      this.setState(function (_ref3) {
        var items = _ref3.items;
        return {
          items: [].concat((0, _toConsumableArray2["default"])(items.slice(0, index)), [item], (0, _toConsumableArray2["default"])(items.slice(index + 1, items.length)))
        };
      });
    }
  }, {
    key: "containsItem",
    value: function containsItem(item) {
      var comparisionFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
        return key;
      };
      var items = this.state.items;
      return items.map(function (aItem) {
        return comparisionFunc(aItem);
      }).includes(comparisionFunc(item));
    }
  }, {
    key: "clearCart",
    value: function clearCart() {
      this.setState({
        items: []
      });
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      var _this$props = this.props,
          _this$props$hours = _this$props.hours,
          hours = _this$props$hours === void 0 ? [] : _this$props$hours,
          _this$props$timezone = _this$props.timezone,
          timezone = _this$props$timezone === void 0 ? 'America/New_York' : _this$props$timezone; // Backend stores weeks starting on Monday, but
      // moment starts on Sunday.

      var translateDay = {
        7: 0,
        // Sunday -> Monday
        1: 1,
        // Monday -> Tuesday
        2: 2,
        // Tuesday -> Wednesday
        3: 3,
        // Wednesday -> Thursday
        4: 4,
        // Thursday -> Friday
        5: 5,
        // Friday -> Saturday
        6: 6 // Saturday -> Sunday

      }; // Find the relevant day...

      var today = _momentTimezone["default"].tz(timezone).day();

      var todaysHours = hours.filter(function (i) {
        return translateDay[i.day] === today;
      })[0];

      var thisHour = _momentTimezone["default"].tz(timezone).hour();

      var thisMinute = _momentTimezone["default"].tz(timezone).minute(); // Convert open and closed hours


      var convertTime = function convertTime(timeToConvert) {
        if (!timeToConvert) return [];
        var formattedTime = CartHOC.normalizeHour(timeToConvert);
        var hour = formattedTime.substring(0, 2);
        var minute = formattedTime.substring(2, 4);

        if (hour === '24') {
          return [parseInt('00', 10), parseInt(minute, 10)];
        }

        return [parseInt(hour, 10), parseInt(minute, 10)];
      };

      var compareTimes = function compareTimes(open, close) {
        if (!open || !close) return false;

        var afterOpen = function afterOpen() {
          if (thisHour > open[0]) return true;
          if (thisHour === open[0]) return thisMinute >= open[1];
          return false;
        };

        var beforeClose = function beforeClose() {
          if (thisHour < close[0]) return true;
          if (thisHour === close[0]) return thisMinute <= close[1];
          return false;
        };

        return afterOpen() && beforeClose();
      };

      if (todaysHours) {
        var todayOpen = todaysHours.open;

        if (todayOpen) {
          var convertedOpen = convertTime(todayOpen);
          var todayClose = todaysHours.close;

          if (todayClose) {
            var convertedClose = convertTime(todayClose);
            return compareTimes(convertedOpen, convertedClose);
          }
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var items = this.state.items;
      return children({
        items: items,
        isOpen: this.isOpen(),
        addItem: this.addItem,
        removeItem: this.removeItem,
        updateItem: this.updateItem,
        containsItem: this.containsItem,
        clearCart: this.clearCart,
        getItemIndex: this.getItemIndex
      });
    }
  }]);
  return CartHOC;
}(_react["default"].Component);

exports["default"] = CartHOC;
CartHOC.propTypes = {
  children: _propTypes["default"].func
};
CartHOC.defaultProps = {
  children: function children() {
    return null;
  }
};